import { NgModule } from '@angular/core';
import { ExpanderComponent } from './components/expander/expander.component';
import { TabExpanderComponent } from './components/tab-expander/tab-expander.component';
import { ExpanderSectionComponent } from './components/expander-section/expander-section.component';
import { ExpansionSectionHeaderComponent } from './components/expansion-section-header/expansion-section-header.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [ExpanderComponent, TabExpanderComponent, ExpanderSectionComponent, ExpansionSectionHeaderComponent],
	imports: [CommonModule, TranslateModule],
	providers: [],
	exports: [ExpanderComponent, TabExpanderComponent, ExpanderSectionComponent, ExpansionSectionHeaderComponent],
})
export class ExpansionModule {}

export * from './expansion.service';
export * from './components/expander/expander.component';
export * from './components/tab-expander/tab-expander.component';
export * from './components/expander-section/expander-section.component';
export * from './components/expansion-section-header/expansion-section-header.component';
export * from './types/expansion';
